export const APP_NAVIGATION = [
    { name: 'General', href: '/settings', current: true },
    { name: 'Access Keys', href: '/access-keys', current: false },
    { name: 'Agent', href: '/agent/settings', current: false },
    { name: 'LLM', href: '/llm', current: false },
    { name: 'Voice AI', href: '/voice', current: false },
];

